import { http } from '../../../utils/http'

export interface Permission {
  key: string
  value: string
}

export interface PermissionsResponse {
  success: boolean
  data: Permission[]
  message?: string
}

export const fetchPermissions = async (): Promise<PermissionsResponse> => {
  try {
    const response = await http.get('/user/pvt/permissions')
    const data = response.data
    
    // Ensure we always return a valid structure
    if (data && typeof data === 'object' && data.success) {
      // API now returns data as an array of key-value pair objects: [{ key: "key1", value: "Value 1" }, ...]
      let permissionsArray: Permission[] = []
      
      if (data.data) {
        if (Array.isArray(data.data)) {
          // Data is now an array of key-value pair objects: [{ key: "key1", value: "Value 1" }, ...]
          permissionsArray = data.data.map((item: any) => ({
            key: String(item.key || ''),
            value: String(item.value || item.key || '')
          }))
        } else {
          // Backward compatibility: if it's still an object, convert to array
          permissionsArray = Object.entries(data.data).map(([key, value]) => ({
            key,
            value: String(value)
          }))
        }
      }
      
      return {
        success: data.success ?? true,
        data: permissionsArray,
        message: data.message
      }
    }
    
    // Fallback if response structure is unexpected
    return {
      success: false,
      data: [],
      message: 'Unexpected response format'
    }
  } catch (error) {
    console.error('Error fetching permissions:', error)
    // Return empty array on error instead of throwing
    return {
      success: false,
      data: [],
      message: 'Failed to fetch permissions'
    }
  }
}

